module.exports = __webpack_public_path__ + "img/diy-UhHu.34e3599a.svg";